// extracted by mini-css-extract-plugin
export default {"panel":"hint-panel_panel__DM119"};